<template>
	<div class="table-footer">
		<div class="row">
			<div class="col-md-4">
				<span>Show</span>
				<select
					class="form-control"
					v-model="showPerPage"
					id="resultsPerPage"
					@change="showPerPageChanged"
				>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
				</select>
				<span>entries</span>
			</div>
			<div class="col-md-4 text-center"></div>
			<div class="col-md-4 text-right">
				<a href="javascript:void(0)" v-if="currentPageNumber!=1" @click="getPreviousPageList()">Previous</a>
				<select
					class="form-control selectpicker"
					style="max-width:70px;padding:2px"
					id="brandFilter"
					v-model="currentPageNumber"
					@change="getNewPageList()"
				>
					<option v-for="index in totalNoOfPages" :key="index" :value="index">{{index}}</option>
				</select>
				<a
					href="javascript:void(0)"
					v-if="(showPerPage == activityList.length) && (currentPageNumber!=totalNoOfPages)"
					@click="getNextPageList()"
				>Next</a>
				<div style="padding-right:0px;padding-top:5px">{{getCount()}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ActivityFooter",
		data() {
			return {
				totalNoOfPages: 1,
			};
		},
		watch: {
			totalActivityDataCount() {
				this.calculateIndexPerPage();
			}
		},

		computed: {
			showPerPage: {
				set(val) {
					this.currentPageNumber = 1;
					this.$store.state.showPerPage = val
					sessionStorage.setItem("activity:showPerPage", val);
				},
				get() {
					if (sessionStorage.getItem("activity:showPerPage")) {
						return sessionStorage.getItem("activity:showPerPage");
					}
					return this.$store.state.showPerPage;
				}
			},
			currentPageNumber: {
				set(val) {
					this.$store.state.currentPageNumber = val;
				},
				get() {
					return this.$store.state.currentPageNumber;
				}
			},
			activityList() {
				return this.$store.state.campaign.activityList;
			}
		},
		props: ["totalActivityDataCount"],

		mounted() {
			this.calculateIndexPerPage();
		},
		methods: {
			calculateIndexPerPage() {
				this.totalNoOfPages = Math.ceil(
					this.totalActivityDataCount / this.showPerPage
				);
				if (this.currentPageNumber > this.totalNoOfPages) {
					this.currentPageNumber = this.totalNoOfPages;
				}
			},
			getPreviousPageList() {
				if (this.currentPageNumber <= 1) {
					return;
				} else {
					this.currentPageNumber -= 1;
					this.$emit("getActivityData", {
						currentPage: this.currentPageNumber - 1,
						showPerPage: this.showPerPage
					});
				}
			},
			getNextPageList() {
				this.currentPageNumber += 1;
				this.$emit("getActivityData", {
					currentPage: this.currentPageNumber - 1,
					showPerPage: this.showPerPage
				});
			},
			getNewPageList() {
				this.$emit("getActivityData", {
					currentPage: this.currentPageNumber - 1,
					showPerPage: this.showPerPage
				});
			},
			getCount() {
				let pageCount = this.showPerPage * (this.currentPageNumber - 1);
				let extendedcount =
					parseInt(pageCount) + parseInt(this.activityList.length);
				return (
					"Showing " +
					(pageCount + 1) +
					" to " +
					extendedcount +
					" results of " +
					this.totalActivityDataCount
				);
			},
			showPerPageChanged() {
				this.currentPageNumber = 1;
				this.$emit("getActivityData", {
					currentPage: this.currentPageNumber - 1,
					showPerPage: sessionStorage.getItem("activity:showPerPage") || this.$store.state.showPerPage
				});
				this.calculateIndexPerPage();
			}
		}
	};
</script>

<style lang="scss">
</style>
